class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.anchor = this.querySelector("a");
    if (!this.anchor) return;

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadNextPage();
        }
      });
    });

    this.observer.observe(this);
  }

  async loadNextPage() {
    const searchQuery = new URLSearchParams(window.location.search).get('q');

    if (searchQuery) {
      this.observer.disconnect();
      this.remove();
      return;
    }

    this.observer.disconnect();
    this.anchor.style.display = "flex";
    this.anchor.innerHTML = `<span class="spinner"></span>`;

    let url = this.anchor.getAttribute("href");
    if (!url) return;

    const currentParams = new URLSearchParams(window.location.search);
    const nextURL = new URL(url, window.location.origin);

    currentParams.forEach((value, key) => {
      if (key !== "page") nextURL.searchParams.set(key, value);
    });

    try {
      const res = await fetch(nextURL.toString());
      const html = new DOMParser().parseFromString(await res.text(), "text/html");

      const newGrid = html.querySelector("[data-product-grid]");
      const grid = document.querySelector("[data-product-grid]");

      if (newGrid && grid) {
        [...newGrid.children].forEach(child => grid.appendChild(child));
        window.productCards = [...grid.querySelectorAll('product-card')];

        const q = new URLSearchParams(window.location.search).get('q');
        if (q) {
          document.querySelector('#live-search-input')
            ?.dispatchEvent(new Event('input'));
        }
      }

      const newInfinite = html.querySelector("infinite-scroll");
      newInfinite ? this.replaceWith(newInfinite) : this.remove();

    } catch (e) {
      console.error("InfiniteScroll error:", e);
    }
  }
}

customElements.define("infinite-scroll", InfiniteScroll);